module.exports = __webpack_public_path__ + "31ff74b19f8f1cbfd26e1340afacdd7c.png";